import { render } from "./Toastr.vue?vue&type=template&id=bdb20c42"
const script = {}

import "./Toastr.vue?vue&type=style&index=0&id=bdb20c42&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__